import { Navbar, Footer } from '@bq/web-components';
import { Outlet, useNavigate } from 'react-router';
import styles from './MarketingSurface.module.css';

export function MarketingSurface() {
  const navigate = useNavigate();

  const handleSignUp = () => {
    const pricing = document.getElementById('pricing');
    if (pricing) {
      pricing.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#pricing');
    }
  };

  return (
    <div data-crd-id="r6.bq-marketing-surface" data-crd-layer="r6" className={styles.surface}>
      <Navbar onSignUp={handleSignUp} />
      <Outlet context={{ onSignUp: handleSignUp }} />
      <Footer />
    </div>
  );
}
